<template>
  <div class="logic-value-input">
    <v-autocomplete
      v-if="type === 'product_id'"
      :append-icon="mode === 'preview' ? null : '$dropdown'"
      :disabled="mode === 'preview'"
      v-model="autocompleteValue"
      item-value="id"
      item-text="sku"
      :multiple="operator === 'in'"
      deletable-chips
      :items="products"
      :search-input.sync="search"
      dense
      no-filter
      hide-details
      outlined
      persistent-placeholder
      placeholder="Select a product"
      @change="search=''"
    >
      <template v-slot:item="{ item, on, attrs }">
        <v-list-item v-on="on" v-bind="attrs">
          <v-checkbox v-if="operator === 'in'" v-model="attrs.inputValue"></v-checkbox>
          <v-list-item-content>
            <v-list-item-title>
              {{item.sku}} - {{item.name}}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:selection="{ item, attrs, selected, select }">
        <div>
          <div v-if="operator !== 'in'">
            {{item.sku}} - {{item.name}}
          </div>
          <v-chip
            :disabled="mode === 'preview'"
            v-else
            v-bind="attrs"
            :input-value="selected"
            :close="mode !== 'preview'"
            @click="select"
            @click:close="remove(item)"
          >
           {{ item.sku }} - {{ item.name }}
          </v-chip>
        </div>
      </template>
    </v-autocomplete>

    <v-autocomplete v-else-if="type === 'brand_id'"
      :append-icon="mode === 'preview' ? null : '$dropdown'"
      :disabled="mode === 'preview'"
      v-model="autocompleteValue"
      :chips="operator === 'in' "
      :multiple="operator === 'in'"
      deletable-chips
      :items="brands"
      :search-input.sync="search"
      item-text="name"
      item-value="id"
      dense
      hide-details
      outlined
      persistent-placeholder
      placeholder="Select a brand"
      @change="search=''"
    ></v-autocomplete>

    <v-autocomplete v-else-if="type === 'location_country_code'"
      :append-icon="mode === 'preview' ? null : '$dropdown'"
      :disabled="mode === 'preview'"
      v-model="autocompleteValue"
      :chips="operator === 'in' "
      :multiple="operator === 'in'"
      deletable-chips
      :items="countries"
      :search-input.sync="search"
      item-text="name"
      item-value="code"
      dense
      hide-details
      outlined
      persistent-placeholder
      placeholder="Select a country"
      @change="search=''"
    >
      <template v-if="operator === 'in'" #prepend-item >
        <v-list-item
          v-for="countryGroup in countryGroups"
          :key="countryGroup.code"
          @click="toggleCountryGroup(countryGroup)"
        >
          <v-list-item-action>
            <v-checkbox
              :input-value="isCountryGroupSelected(countryGroup)"
              hide-details
              dense
            />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ countryGroup.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mb-1" />
      </template>
    </v-autocomplete>

    <v-autocomplete v-else-if="type === 'device_language'"
      :append-icon="mode === 'preview' ? null : '$dropdown'"
      :disabled="mode === 'preview'"
      v-model="autocompleteValue"
      :chips="operator === 'in' "
      :multiple="operator === 'in'"
      deletable-chips
      :items="languages"
      :search-input.sync="search"
      item-text="name"
      item-value="code"
      dense
      hide-details
      outlined
      persistent-placeholder
      placeholder="Select a device language"
      @change="search=''"
    ></v-autocomplete>

    <v-autocomplete v-else-if="type === 'scan_activation_status'"
      :append-icon="mode === 'preview' ? null : '$dropdown'"
      :disabled="mode === 'preview'"
      v-model="autocompleteValue"
      :chips="operator === 'in' "
      :multiple="operator === 'in'"
      deletable-chips
      :items="activationStatuses"
      :search-input.sync="search"
      item-text="description"
      item-value="value"
      dense
      hide-details
      outlined
      persistent-placeholder
      placeholder="Select a scan status"
      @change="search=''"
    ></v-autocomplete>

    <v-autocomplete v-else-if="type === 'scan_result'"
      :disabled="mode === 'preview'"
      :append-icon="mode === 'preview' ? null : '$dropdown'"
      v-model="autocompleteValue"
      :chips="operator === 'in' "
      :multiple="operator === 'in'"
      deletable-chips
      :items="scanResults"
      :search-input.sync="search"
      item-text="description"
      item-value="value"
      dense
      hide-details
      outlined
      persistent-placeholder
      placeholder="Select a scan result"
      @change="search=''"
    ></v-autocomplete>

    <v-autocomplete v-else-if="type === 'calculated_auth_result'"
      :append-icon="mode === 'preview' ? null : '$dropdown'"
      :disabled="mode === 'preview'"
      v-model="autocompleteValue"
      :chips="operator === 'in' "
      :multiple="operator === 'in'"
      deletable-chips
      :items="computedAuthResults"
      :search-input.sync="search"
      item-text="description"
      item-value="value"
      dense
      hide-details
      outlined
      persistent-placeholder
      placeholder="Select a scan result"
      @change="search=''"
    ></v-autocomplete>

    <v-autocomplete v-else-if="type === 'scan_app_slug'"
      :append-icon="mode === 'preview' ? null : '$dropdown'"
      :disabled="mode === 'preview'"
      v-model="autocompleteValue"
      :chips="operator === 'in' "
      :multiple="operator === 'in'"
      deletable-chips
      :items="apps"
      :search-input.sync="search"
      item-text="name"
      item-value="slug"
      dense
      hide-details
      outlined
      persistent-placeholder
      placeholder="Select a scan application"
      @change="search=''"
    ></v-autocomplete>

    <v-autocomplete v-else-if="type === 'scan_reason'"
      :append-icon="mode === 'preview' ? null : '$dropdown'"
      :disabled="mode === 'preview'"
      v-model="autocompleteValue"
      :chips="operator === 'in' "
      :multiple="operator === 'in'"
      deletable-chips
      :items="scanReasons"
      :search-input.sync="search"
      item-text="description"
      item-value="value"
      dense
      hide-details
      outlined
      persistent-placeholder
      placeholder="Select a scan reason"
      @change="search=''"
    ></v-autocomplete>

     <v-autocomplete v-else-if="type === 'scan_region_key'"
      :disabled="mode === 'preview'"
      :append-icon="mode === 'preview' ? null : '$dropdown'"
      v-model="autocompleteValue"
      :chips="operator === 'in' "
      :multiple="operator === 'in'"
      deletable-chips
      :items="customRegions"
      :search-input.sync="search"
      item-text="name"
      item-value="key"
      dense
      hide-details
      outlined
      persistent-placeholder
      placeholder="Select a custom region"
      @change="search=''"
    ></v-autocomplete>

     <v-autocomplete v-else-if="type === 'scan_blacklist_reason'"
      :disabled="mode === 'preview'"
      :append-icon="mode === 'preview' ? null : '$dropdown'"
      v-model="autocompleteValue"
      :chips="operator === 'in' "
      :multiple="operator === 'in'"
      deletable-chips
      :items="blacklistReasons"
      :search-input.sync="search"
      item-text="description"
      item-value="value"
      dense
      hide-details
      outlined
      persistent-placeholder
      placeholder="Select a blacklist reason"
      @change="search=''"
    ></v-autocomplete>

    <v-combobox v-else-if="operator === 'in'"
      :disabled="mode === 'preview'"
      :append-icon="mode === 'preview' ? null : '$dropdown'"
      :value="this.value"
      v-model="comboBoxValue"
      chips
      multiple
      deletable-chips
      dense
      outlined
      hide-details
      @change="onComboChange"
    ></v-combobox>

    <v-text-field  :disabled="mode === 'preview'" outlined dense hide-details persistent-placeholder placeholder="Enter a value" v-else :value="this.value" @input="updateValue($event)"></v-text-field>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import Countries from '@/utils/countries'
import CountryGroups from '@/utils/countryGroups'
import Languages from '@/utils/languages'

// Fields whose value must be stored/sent as an integer in the JSONlogic.
// Coercing here (rather than only at the store level) also self-heals legacy
// conditions that were saved with string values, so they still match the
// integer-valued autocomplete items on load.
const INT_VALUE_TYPES = ['brand_id', 'product_id', 'scan_activation_status', 'scan_blacklist_reason']

export default {
  name: 'LogicValueInput',
  props: ['type', 'value', 'operator', 'mode'],
  computed: {
    ...mapGetters(['activationStatuses', 'apps', 'brands', 'customRegions', 'scanResults', 'computedAuthResults', 'scanReasons', 'blacklistReasons'])
  },
  watch: {

    type (newVal, oldVal) {
      if (this.mode === 'preview') {
        this.autocompleteValue = this.value
        this.comboBoxValue = this.value
      }
      this.search = ''
      if (this.operator === 'in') {
        this.$emit('update:value', [])
      } else {
        this.$emit('update:value', '')
      }
    },

    autocompleteValue (newVal) {
      const coerced = this.castToInt(newVal)
      // Skip re-emitting when the coerced value is unchanged. castToInt returns a
      // fresh array for the "in" operator, so an unguarded emit would churn the
      // parent's value reference (and would loop if the .sync write ever became reactive).
      if (this.valuesEqual(coerced, this.value)) {
        return
      }
      this.$emit('update:value', coerced)
    },

    // autocompleteValue (newVal) {
    //   console.log('udp->', newVal, this.operator)
    //   if (this.operator !== 'in' && typeof newVal === 'object') {
    //     console.log('hack', newVal[newVal.length - 1])
    //     this.$emit('update:value', newVal[newVal.length - 1])
    //   } else {
    //     this.$emit('update:value', newVal)
    //   }
    //   this.$forceUpdate()
    // },

    value (newVal, oldVal) {
      this.autocompleteValue = this.castToInt(newVal)
      this.comboBoxValue = this.value
      // if (this.mode === 'preview') {
      //   this.autocompleteValue = newVal
      //   this.comboBoxValue = this.value
      // }
      this.$forceUpdate()
    },

    search () {
      if (this.type === 'product_id') {
        this.loadProducts(this.autocompleteValue)
      }
    }
  },

  data () {
    return {
      autocompleteValue: null,
      comboBoxValue: null,
      search: '',
      countries: Countries,
      countryGroups: CountryGroups,
      languages: Languages,
      products: []
    }
  },
  methods: {

    // convert specific fields to int in order for JSON logic to work properly with 'in' operator
    castToInt (val) {
      if (!INT_VALUE_TYPES.includes(this.type)) {
        return val
      }
      const toInt = (v) => {
        if (v === null || v === undefined || v === '') {
          return v
        }
        const parsed = parseInt(v)
        return isNaN(parsed) ? v : parsed
      }
      return Array.isArray(val) ? val.map(toInt) : toInt(val)
    },

    // Shallow value comparison that treats two arrays with equal ordered members as equal,
    // so we don't emit a new reference for the same selection (e.g. the "in" operator).
    valuesEqual (a, b) {
      if (Array.isArray(a) && Array.isArray(b)) {
        return a.length === b.length && a.every((v, i) => v === b[i])
      }
      return a === b
    },

    onComboChange () {
      this.$emit('update:value', this.comboBoxValue)
    },

    async loadProducts () {
      this.products = await this.$store.dispatch('searchProducts', { offset: 0, limit: 500, search: this.search })
    },

    updateValue (val) {
      this.$emit('update:value', val)
    },

    remove (item) {
      const index = this.autocompleteValue.indexOf(item.id)
      if (index >= 0) this.autocompleteValue.splice(index, 1)
    },

    isCountryGroupSelected (countryGroup) {
      return countryGroup.countryCodes.every(code => this.autocompleteValue.includes(code))
    },

    toggleCountryGroup (countryGroup) {
      const selectedCountryCodes = new Set(this.autocompleteValue)
      if (this.isCountryGroupSelected(countryGroup)) {
        countryGroup.countryCodes.forEach(code => selectedCountryCodes.delete(code))
      } else {
        countryGroup.countryCodes.forEach(code => selectedCountryCodes.add(code))
      }
      this.autocompleteValue = [...selectedCountryCodes]
    }
  },
  created () {
    if (!this.activationStatuses.length) {
      this.$store.dispatch('loadActivationStatuses')
    }

    if (!this.scanResults.length) {
      this.$store.dispatch('loadScanResults')
    }

    if (!this.apps.length) {
      this.$store.dispatch('loadAppsList')
    }

    if (!this.brands.length) {
      this.$store.dispatch('loadBrands')
    }

    if (!this.customRegions.length) {
      this.$store.dispatch('loadCustomRegions')
    }

    if (!this.computedAuthResults.length) {
      this.$store.dispatch('loadComputedAuthResults')
    }

    if (!this.blacklistReasons.length) {
      this.$store.dispatch('loadBlacklistReasons')
    }

    // Use an explicit emptiness check rather than a truthiness check so that a
    // legitimate 0 value (e.g. scan_activation_status) is still applied to the input.
    if (this.value !== null && this.value !== undefined && this.value !== '') {
      if (this.operator !== 'in' && typeof this.value === 'object' && this.value.length) {
        this.$emit('update:value', this.castToInt(this.value[0]))
        this.autocompleteValue = this.castToInt(this.value[0])
        this.comboBoxValue = this.value[0]
      } else {
        this.autocompleteValue = this.castToInt(this.value)
        this.comboBoxValue = this.value
      }
    }
  }
}

</script>

<style lang="sass" scoped>

</style>
